/**
 * Pan slot component.  @deprecated Pan is deprecated, please use `</[Chart].Pan>` instead.
 *
 */
export const Pan = () => null;
/* eslint-disable-next-line @typescript-eslint/no-deprecated */
Pan['displayName'] = 'Pan';
